export const caseDetails = [
  {
    id: "case-01",
    hook: "一句关于绿萝的随口提问，让三个月的加班话术当场失效。",
    timeline: [
      { label: "01 · 异样", text: "她发现他每次「加班」的外卖地址都停在城东同一个商圈，而他的公司在城西，中间隔着整整一条环线。" },
      { label: "02 · 试探", text: "她没质问，只是在电话里随口聊起他工位上的那盆绿萝，问他最近还记不记得浇水。" },
      { label: "03 · 沉默", text: "电话那头安静了十一秒，然后是一句「我明天跟你解释」。她心里其实已经有了答案。" },
    ],
    verdict: "需要靠沉默来掩护的借口，通常已经撑不住了。先保存好证据，再决定要不要听他解释。",
  },
  {
    id: "case-02",
    hook: "凌晨一点十七分，一条深夜情话出现在家族群里。",
    timeline: [
      { label: "01 · 手滑", text: "他在复制粘贴时点错了会话窗口，把写给别人的长段情话，发进了三百多人的家族群。" },
      { label: "02 · 撤回", text: "三分钟后他慌忙撤回，但姑妈、二舅和表妹的手速比撤回按钮更快，截图已经在群里流转。" },
      { label: "03 · 炸群", text: "第二天早上，家族群第一条消息是妈妈发的：「你昨晚发的那段，是给谁的？」" },
    ],
    verdict: "复制粘贴出来的真心话，最容易先暴露在错误的收件人那里。",
  },
  {
    id: "case-03",
    hook: "纪念日的订位短信发到了她手机上，收件人却写着另一个名字。",
    timeline: [
      { label: "01 · 破绽", text: "订位确认短信误发到她手机，备注名不是她，用餐人数却写着两位。" },
      { label: "02 · 对峙", text: "她没吵，只是把手机屏幕转了个方向推到他面前，安静地等他开口。" },
      { label: "03 · 凝固", text: "对面的笑一寸一寸僵住，从「你听我解释」到「我没什么好说的」，只用了不到两分钟。" },
    ],
    verdict: "纪念日最怕的不是忘记，而是他记得很清楚，只是记的是别人。",
  },
  {
    id: "case-04",
    hook: "所有亲友都在台下，伴郎只是问了一句不该问的话。",
    timeline: [
      { label: "01 · 彩排", text: "婚礼彩排现场，双方亲友坐了满满一厅，气氛本来轻松热闹。" },
      { label: "02 · 玩笑", text: "伴郎随口一句「上次那事你处理好了吗」，原本的笑声戛然而止。" },
      { label: "03 · 社死", text: "全场安静得能听见音响电流声，他的脸色在三秒内换了四种颜色，新娘转过身看向他。" },
    ],
    verdict: "最伤人的往往不是背叛本身，而是它被当众摆上台面的那一刻。",
  },
  {
    id: "case-05",
    hook: "他把「出差」做成了行程表，却在行李箱夹层里露了馅。",
    timeline: [
      { label: "01 · 行程表", text: "他的出差行程写得极其工整，连航班号、酒店地址都记得清清楚楚。" },
      { label: "02 · 发票", text: "她顺手整理行李时发现，酒店发票的房型是双床房，而他却说自己是单独开的单间。" },
      { label: "03 · 夹层", text: "行李箱夹层里那张合影，让所有的时间线在同一个晚上彻底对不上。" },
    ],
    verdict: "越完整的行程表，越需要一条能自洽的时间线。核对细节，比反复质问更有效。",
  },
  {
    id: "case-06",
    hook: "她提前一小时回家想给个惊喜，门却开着。",
    timeline: [
      { label: "01 · 惊喜", text: "她提前结束出差，想在他下班前到家，准备一顿不声张的晚饭。" },
      { label: "02 · 现场", text: "推开门时客厅摆着两份餐具，玄关多了一双不属于这个家的拖鞋。" },
      { label: "03 · 藏花", text: "他从房间出来，下意识把手里的花藏到身后，那个动作比任何解释都更直接。" },
    ],
    verdict: "撞见的那一刻不需要台词。你要做的是先保护好自己，再考虑下一步怎么走。",
  },
  {
    id: "case-07",
    hook: "同一间咖啡厅里，她的定位、朋友圈和聊天记录互相对不上。",
    timeline: [
      { label: "01 · 巧合", text: "朋友在咖啡厅偶遇她，说好「在外地探亲」的人，就坐在靠窗的位置。" },
      { label: "02 · 对不上", text: "朋友圈的定位还停在两百公里外的城市，手机里的消息却显示她一个小时前刚取消了一单外卖。" },
      { label: "03 · 摊牌", text: "当事人只是走过去打了声招呼，剩下的解释，已经没有任何一个版本能自圆其说。" },
    ],
    verdict: "说谎的成本，往往是在一个最不起眼的下午被一次性补齐的。",
  },
  {
    id: "case-08",
    hook: "保证书写得工工整整，第二天就在别人的评论区出现同款情话。",
    timeline: [
      { label: "01 · 保证", text: "他手写了一整页保证书，逐条列明以后不再联系、不再隐瞒、随时报备。" },
      { label: "02 · 复制", text: "第二天夜里，有人发现他在别人的动态下留了一句话，和保证书里的某段几乎一字不差。" },
      { label: "03 · 打脸", text: "截图被转回给她时，她把那张保证书折起来，扔进了垃圾桶。" },
    ],
    verdict: "真正会改的人不需要写保证书，需要写保证书的人，通常也写不了第二次。",
  },
  {
    id: "case-09",
    hook: "三个不同城市的姑娘，在同一个话题下比对了各自的「周末加班」。",
    timeline: [
      { label: "01 · 留言", text: "一条吐槽视频下，三个来自不同城市的读者先后留言，讲的却是几乎一样的情节。" },
      { label: "02 · 比对", text: "她们在私信里交换了语音、礼物和借口，发现连「信号不好」的时间点都高度重合。" },
      { label: "03 · 合辑", text: "三条时间线拼在一起，拼出了同一个人反复使用的同一套台词。" },
    ],
    verdict: "当一套话术被反复复用，它就不再是巧合，而是一份可以提前识别的说明书。",
  },
];